import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { ReceiptLong } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const HANDLES = [
  { id: "success", color: "#4caf50", label: "Com faturas" },
  { id: "sem_faturas", color: "#ff9800", label: "Sem faturas" },
  { id: "error", color: "#f44336", label: "Erro" },
];

const IxcBuscarFaturaNode = memo(({ id, data, isConnectable, selected }) => {
  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ReceiptLong />}
      title="IXC: Buscar Fatura"
      color="#00695c"
      bgColor="#E8F5F1"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={240}
    >
      {/* Variable chip */}
      {data?.idClienteVariable && (
        <div style={{ marginBottom: 6 }}>
          <span style={{ fontSize: 9, color: "#888", display: "block", marginBottom: 2 }}>
            ID Cliente
          </span>
          <span style={{
            display: "inline-block",
            fontFamily: "'Fira Mono', 'Consolas', monospace",
            fontSize: 11, background: "#00695c15", color: "#00695c",
            borderRadius: 6, padding: "2px 8px", border: "1px solid #00695c25",
          }}>
            {data.idClienteVariable}
          </span>
        </div>
      )}

      {/* Handle rows at node edge */}
      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 4 }}>
        {HANDLES.map((h) => (
          <div key={h.id} style={{
            display: "flex", alignItems: "center", justifyContent: "flex-end",
            gap: 6, position: "relative", paddingRight: 4,
          }}>
            <span style={{
              fontSize: 9, fontWeight: 600, color: "#fff",
              background: h.color, borderRadius: 10,
              padding: "1px 8px", lineHeight: "16px", whiteSpace: "nowrap",
            }}>
              {h.label}
            </span>
            <Handle
              type="source" position={Position.Right} id={h.id}
              style={{
                position: "absolute", top: "50%", right: -13,
                transform: "translateY(-50%)",
                background: h.color, width: 14, height: 14,
                border: "2px solid #E8F5F1", borderRadius: "50%", cursor: "crosshair",
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
      </div>
    </NodeWrapper>
  );
});

IxcBuscarFaturaNode.displayName = "IxcBuscarFaturaNode";
export default IxcBuscarFaturaNode;
